function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PageBaseComponent } from "../../library/cms/page-components";
import Carousel from "../components/carousel";
export default class AboutCarousel extends PageBaseComponent {
  constructor(props) {
    super(props);

    _defineProperty(this, "onFilesSelected", files => {
      this.state.component.content.media = files;
      this.setState(this.state.component);
    });

    _defineProperty(this, "onFilesCancel", () => {});

    _defineProperty(this, "onEditClick", event => {
      this.mediaController.mode = 'multi-select';
      this.mediaController.show(this.state.component.content.media);
    });
  }

  componentDidMount() {
    super.componentDidMount();
  }

  render() {
    return /*#__PURE__*/React.createElement(Carousel, {
      files: this.state.component.content.media,
      active: this.state.component.active,
      mediaManagerData: this.props.mediaManagerData,
      onFilesSelected: this.onFilesSelected
    });
  }

}